"use strict";

var _PageView = _interopRequireDefault(require("../components/collection_campaign_page/PageView"));

var _GetACardModal = _interopRequireDefault(require("../components/GetACardModal/GetACardModal"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

void (window.pageView = new _PageView["default"]({
  el: '.Carousels',
  viewId: 'home',
  bus: window.globalEvents,
  room: window.OverDrive.currentRoom,
  featureManager: window.featureManager,
  patronSettings: window.patronSettings
}));
$(function () {
  if (window.OverDrive.showGetACardModal) {
    new _GetACardModal["default"]();
  }
});